import AnonymousNavigator from './AnonymousNavigator';
export default AnonymousNavigator;
